export default {
  title: {
    id: 'bo_sellers-orders-drawers-order_recap-contact_block-title',
    defaultMessage: 'Need to contact your customer?',
  },
  description: {
    id: 'bo_sellers-orders-drawers-order_recap-contact_block-content',
    defaultMessage:
      'Start the conversation over on the after-sales services platform.',
  },
  action: {
    id: 'bo_sellers-orders-drawers-order_recap-contact_block-cta',
    defaultMessage: 'Contact them',
  },
} as const
